<template>
  <div class="d-flex justify-content-center">
    <router-link class="go_to_route" :to="routeName">{{
      linkText
    }}</router-link>
  </div>
</template>
<script>
export default {
  name: "AuthRouters",
  props: {
    routeName: {
      type: String,
    },
    linkText: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
.go_to_route {
  color: $text_color;
  transition: $transition;
  text-decoration: none;
  &:hover {
    color: $main_color;
  }
}
</style>
